const stage = 'gamma';

export const getCurrentStage = (): string => {
    return stage;
};

export const envConfig = {
    Auth: {
        identityPoolId: 'us-west-2:1eefddc4-cbc3-4b0b-adfc-b00bcba103f6',
        region: 'us-west-2',
        userPoolId: 'us-west-2_BKWoE9WfW',
        userPoolWebClientId: '7uo0qktl6109l5pslh2l9v6qa8',
        mandatorySignIn: true,
        oauth: {
            domain: 'finspace-gamma' + '.auth.us-west-2.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
    API: {
        endpoints: [
            {
                name: 'FinSpaceService',
                endpoint: `https://api.${stage}.service.finspace.finergy.amazon.dev`,
                region: 'us-west-2',
            },
        ],
    },
};
